import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2605238a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2605238a&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=2605238a&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605238a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2605238a')) {
      api.createRecord('2605238a', component.options)
    } else {
      api.reload('2605238a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2605238a&scoped=true&", function () {
      api.rerender('2605238a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/inventory-items/index.vue"
export default component.exports